export default __webpack_public_path__ + "static/HVTILogo-aead2460e1846ff314290ff6d889fe68.png";